import { Platform, ViewStyle } from 'react-native';
import theme from '@/config/theme';

interface AndroidActionSheetSafeAreaOptions {
  bottomInset: number;
  topInset?: number;
  windowHeight?: number;
  constrainHeight?: boolean;
  platform?: string;
}

export const getSettingsHeaderPaddingTop = (topInset: number) => (
  Platform.OS === 'web' ? theme.spacing.lg : topInset + theme.spacing.sm
);

export const getSettingsContentPaddingBottom = (bottomInset: number) => (
  theme.spacing.xl + (Platform.OS === 'web' ? 0 : bottomInset)
);

export const getActionSheetContainerPaddingBottom = (bottomInset: number) => (
  Platform.OS === 'web' ? 0 : Math.max(bottomInset, theme.spacing.sm)
);

export const getAndroidActionSheetSafeAreaStyle = ({
  bottomInset,
  topInset = 0,
  windowHeight,
  constrainHeight = false,
  platform = Platform.OS,
}: AndroidActionSheetSafeAreaOptions): ViewStyle => {
  if (platform !== 'android') return {};

  const style: ViewStyle = {
    paddingBottom: Math.max(0, bottomInset),
  };

  if (constrainHeight && typeof windowHeight === 'number') {
    style.maxHeight = Math.max(0, windowHeight - Math.max(0, topInset));
  }

  return style;
};
